/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Formulas_TitleInputs */

const en_gc_story_formulas_title = /** @type {(inputs: Gc_Story_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let the cells do the calculation.`)
};

const zh_gc_story_formulas_title = /** @type {(inputs: Gc_Story_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让单元格帮你计算。`)
};

/**
* | output |
* | --- |
* | "Let the cells do the calculation." |
*
* @param {Gc_Story_Formulas_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_formulas_title = /** @type {((inputs?: Gc_Story_Formulas_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Formulas_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_formulas_title(inputs)
	return zh_gc_story_formulas_title(inputs)
});
export { gc_story_formulas_title as "gc.story.formulas.title" }